<div class="cd-page">
  <app-counselor-nav />

  <main class="cd-main" aria-label="Meetings">
    <!-- HEADER -->
    <div class="cd-header">
      <div>
        <h1 class="cd-title">Meetings</h1>
      </div>
    </div>
    <nav
      mat-tab-nav-bar
      mat-stretch-tabs="true"
      class="full-width-tabs"
      animationDuration="200ms"
      [tabPanel]="tabPanel"
    >
      @for (link of navLinks; track link.path) {
        <a
          class="cd-tab-title"
          mat-tab-link
          [routerLink]="link.path"
          routerLinkActive
          #rla="routerLinkActive"
          [active]="rla.isActive"
          [attr.data-testid]="'nav-link-' + link.label.toLowerCase()"
          ><span
            [matBadge]="link.count"
            [matBadgeHidden]="!link.count"
            matBadgeColor="warn"
            matBadgeOverlap="false"
            [attr.data-testid]="link.count ? 'pending-count-badge' : null"
          >
            {{ link.label }}
          </span>
        </a>
      }
    </nav>

    <!-- ROUTED MAIN CONTENT -->
    <div class="cd-cols">
      <div class="cd-tab-content">
        <mat-tab-nav-panel #tabPanel>
          <router-outlet></router-outlet>
        </mat-tab-nav-panel>
      </div>

      <!-- RIGHT COLUMN CARDS -->
      <div class="cd-right">
        <!-- UPCOMING MEETINGS -->
        <div class="cd-card">
          <div class="cd-card-header">
            @if (upcomingMeetings.length === 0) {
              <h2>You have no upcoming meetings!</h2>
              <span class="cd-subtitle">Take some time to relax 😎</span>
            } @else {
              <h2>Upcoming Meetings</h2>
            }
          </div>
          <div role="list" aria-label="Upcoming Meeting">
            @for (meeting of upcomingMeetings.slice(0, 3); track meeting.id) {
              <div class="cd-upcoming-meeting" role="listitem">
                <div>
                  <h2 class="cd-student-info">
                    {{ meeting.studentName }} &middot; Grade {{ meeting.gradeLevel }}
                  </h2>
                </div>
                <div class="cd-meeting-info">{{ meeting.title }}</div>
                <time class="cd-meeting-date" [attr.datetime]="meeting.start">{{
                  meeting.start | date: 'EEEE MMMM d @ h:mm a'
                }}</time>
              </div>
            }
          </div>
          @if (upcomingMeetings.length > 3) {
            <button
              class="cd-card-footer"
              routerLink="/counselors/meetings/bookings"
              data-testid="more-upcoming-bookings"
            >
              See more →
            </button>
          }
        </div>

        <!-- PENDING REQUESTS -->
        <div class="cd-card">
          <div class="cd-card-header">
            @if (pendingRequests.length === 0) {
              <h2>No pending requests!</h2>
              <span class="cd-subtitle">Take some time to relax 😎</span>
            } @else {
              <h2>Pending Requests</h2>
            }
          </div>
          <div role="list" aria-label="Upcoming Meeting">
            @for (request of pendingRequests.slice(0, 3); track request.id) {
              <div class="cd-upcoming-meeting" role="listitem">
                <div>
                  <h2 class="cd-student-info">
                    {{ request.studentName }} &middot; Grade {{ request.gradeLevel }}
                  </h2>
                </div>
                <div class="cd-meeting-info">{{ request.title }}</div>
                <time
                  class="cd-meeting-date"
                  [attr.datetime]="request.isChangeRequest ? request.proposedStart : request.start"
                  >{{
                    (request.isChangeRequest ? request.proposedStart : request.start)
                      | date: 'EEEE MMMM d @ h:mm a'
                  }}</time
                >
              </div>
            }
          </div>
          @if (pendingRequests.length > 3) {
            <button
              class="cd-card-footer"
              routerLink="/counselors/meetings/pending"
              data-testid="more-upcoming-meetings"
            >
              See more →
            </button>
          }
        </div>
      </div>
    </div>
  </main>
</div>
